import { Group, Loader, Text } from "@mantine/core";
import { IconAlertCircle, IconCheck } from "@tabler/icons-react";
import { spacing } from "@xplatform/design-system";
import { useTranslation } from "react-i18next";

/** Idle (nothing shown), a decision is being written, saved, or it failed. */
export type SaveState = "idle" | "saving" | "saved" | "error";

/**
 * A slim save/decision status indicator for the toolbar, mirroring the
 * reviewer-app's `SaveStatus`: a spinner while a decision is being written, a
 * green check once saved, and an error note on failure. Hidden when idle.
 */
export function SaveStatus({ state }: { state: SaveState }) {
  const { t } = useTranslation();
  if (state === "idle") return null;

  if (state === "saving") {
    return (
      <Group gap={spacing.xs} wrap="nowrap">
        <Loader size="xs" />
        <Text size="xs" c="dimmed">
          {t("review.save.saving")}
        </Text>
      </Group>
    );
  }

  if (state === "saved") {
    return (
      <Group gap={spacing.xs} wrap="nowrap" c="green">
        <IconCheck size={14} aria-hidden="true" />
        <Text size="xs">{t("review.save.saved")}</Text>
      </Group>
    );
  }

  return (
    <Group gap={spacing.xs} wrap="nowrap" c="rapidRed">
      <IconAlertCircle size={14} aria-hidden="true" />
      <Text size="xs">{t("review.save.failed")}</Text>
    </Group>
  );
}
